import {
    CREATE_COMPACTING_DC_FAILURE,
    CREATE_COMPACTING_DC_REQUEST,
    CREATE_COMPACTING_DC_SUCCESS,
    CREATE_USER_FORM_COMPACTING_DC,
    FETCH_SINGLE_COMPACTING_DC_FAILURE,
    FETCH_SINGLE_COMPACTING_DC_REQUEST,
    FETCH_SINGLE_COMPACTING_DC_SUCCESS,
    FETCH_COMPACTING_DC_FAILURE,
    FETCH_COMPACTING_DC_REQUEST,
    FETCH_COMPACTING_DC_SUCCESS,
    NAVIGATE_COMPACTING_DC_DETAILS,
    NAVIGATE_COMPACTING_DC,
    COMPACTING_DC_USERFORM_RESET,
    UPDATE_COMPACTING_DC_FAILURE,
    UPDATE_COMPACTING_DC_REQUEST,
    UPDATE_COMPACTING_DC_SUCCESS,
    DELETE_COMPACTING_DC_REQUEST,
    DELETE_COMPACTING_DC_SUCCESS,
    DELETE_COMPACTING_DC_FAILURE,
    COMPACTING_DC_USERFORM_NAVIGATE_TO_DETAIL_TAB,
    COMPACTING_DC_USERFORM_NAVIGATE_TO_DETAIL_REVERSE,
    FETCH_COMPACTING_DC_INVOICE_REQUEST,
    FETCH_COMPACTING_DC_INVOICE_SUCCESS,
    FETCH_COMPACTING_DC_INVOICE_FAILURE,
    RESET_COMPACTING_DC_INVOICE_V2,
    FETCH_COMPACTING_DC_STYLE_REQUEST,
    FETCH_COMPACTING_DC_STYLE_SUCCESS,
    FETCH_COMPACTING_DC_STYLE_FAILURE,
    FETCH_COMPACTING_DC_DETAILS_RATE_FROM_STYLE_SUCCESS,
    FETCH_COMPACTING_DC_DETAILS_RATE_FROM_STYLE_FAILURE,
    FETCH_COMPACTING_DC_DETAILS_RATE_FROM_STYLE_REQUEST,
    COMPACTING_DC_DIA_SUCCESS,
    COMPACTING_DC_DIA_REQUEST,
    COMPACTING_DC_DIA_FALIURE,
    DELETE_COMPACTING_DIV_SUCCESS_CALL_OFF,
    DELETE_COMPACTING_DIV_FAILURE_CALL_OFF,
    DELETE_COMPACTING_DIV_REQUEST_CALL_OFF,
    FETCH_COMPACTING_DIVISION_DYEING_DCNO_ID_REQUEST,
    FETCH_COMPACTING_DIVISION_DYEING_DCNO_ID_SUCCESS,
    FETCH_COMPACTING_DIVISION_DYEING_DCNO_ID_FAILURE,
    HEADER_SEARCH_CALL_ONLOAD
} from './compactingDivision.actionsType'

export const COMPACTING_DIVISION = 'compactingDivision';

let initialState = {
    loading: false,
    compactingDivision: [],
    compactingDCInvoiceV2: [],
    compactingDCStyleList: [],
    rateKg: '',
    userform: {
        fldFKDeliveryAt: '',
        fldFKSupplierID: '',
        fldIsInHouseDelivery: false,
        fldIsInHouseProduction: false,
        fldItemsTotalValue: 0,
        fldGrandGrossValue: 0,
        fldOtherPlusValue: 0,
        fldOtherMinusValue: 0,
        fldRoundoff: 0,
        startDate: new Date().setDate(new Date().getDate() - 15),
        endDate: new Date(),
        unitId: 1
    },
    selectedTeam: {},
    DyedDCNOId: [],
    detailsId: '',
    activeKey: 1,
    isCompactingDC: false,
    compactingDCSelectedValue: {},
    errorMessage: '',
    iperrorMessage: '',
    headerSearchCall: true,
};

export let compactingDivisionReducer = (state = initialState, action) => {
    let { type, payload, updatePayload } = action;
    if (type === 'CREATE_COMPACTING_DC_SUCCESS') {
        localStorage.setItem('DetailStyleIdComp', JSON.stringify(updatePayload));
    }
    switch (type) {
        case FETCH_COMPACTING_DC_REQUEST:
        case FETCH_COMPACTING_DC_STYLE_REQUEST:
        case CREATE_COMPACTING_DC_REQUEST:
        case FETCH_COMPACTING_DC_INVOICE_REQUEST:
        case FETCH_SINGLE_COMPACTING_DC_REQUEST:
        case UPDATE_COMPACTING_DC_REQUEST:
        case DELETE_COMPACTING_DC_REQUEST:
        case FETCH_COMPACTING_DC_DETAILS_RATE_FROM_STYLE_REQUEST:
        case COMPACTING_DC_DIA_REQUEST:
        case FETCH_COMPACTING_DIVISION_DYEING_DCNO_ID_REQUEST:
            return {
                ...state,
                loading: true
            };
        case HEADER_SEARCH_CALL_ONLOAD:
            return {
                ...state,
                loading: false,
                headerSearchCall: payload
            }
        case DELETE_COMPACTING_DIV_REQUEST_CALL_OFF:
            return {
                ...state,
                loading: false,
                callOffCheck: updatePayload
            }
        case FETCH_COMPACTING_DC_SUCCESS:
            return {
                ...state,
                loading: false,
                compactingDivision: updatePayload
            };
        case FETCH_COMPACTING_DC_INVOICE_SUCCESS:
            return {
                ...state,
                loading: false,
                compactingDCInvoiceV2: updatePayload
            };
        case FETCH_COMPACTING_DC_STYLE_SUCCESS:
            return {
                ...state,
                loading: false,
                compactingDCStyleList: updatePayload?.PONO
            };

        case CREATE_COMPACTING_DC_SUCCESS:
            return {
                ...state,
                loading: false,
                userform: {
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldIsInHouseDelivery: false,
                    fldIsInHouseProduction: false,
                    fldItemsTotalValue: 0,
                    fldGrandGrossValue: 0,
                    fldOtherPlusValue: 0,
                    fldOtherMinusValue: 0,
                    fldRoundoff: 0,
                    startDate: state.userform.startDate,
                    endDate: state.userform.endDate,
                    unitId: state.userform.unitId
                },
                detailsId: updatePayload
            };
        case FETCH_SINGLE_COMPACTING_DC_SUCCESS:
            return {
                ...state,
                loading: false,
                selectedTeam: updatePayload,
                userform: {
                    ...updatePayload, startDate: state.userform.startDate,
                    endDate: state.userform.endDate,
                    unitId: state.userform.unitId
                }
            };
        case UPDATE_COMPACTING_DC_SUCCESS:
            return {
                ...state,
                loading: false,
                userform: {
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldIsInHouseDelivery: false,
                    fldIsInHouseProduction: false,
                    fldItemsTotalValue: 0,
                    fldGrandGrossValue: 0,
                    fldOtherPlusValue: 0,
                    fldOtherMinusValue: 0,
                    fldRoundoff: 0,
                    startDate: state.userform.startDate,
                    endDate: state.userform.endDate,
                    unitId: state.userform.unitId
                },
                detailsId: ''
            };
        case FETCH_COMPACTING_DC_DETAILS_RATE_FROM_STYLE_SUCCESS:
            // return {
            //     ...state,
            //     loading: false,
            //     rateKg: updatePayload
            // };
            return {
                ...state,
                loading: false,
                userform: { ...state.userform, fldRate: updatePayload }
            };
        case DELETE_COMPACTING_DC_SUCCESS:
            return {
                ...state,
                loading: false,
                userform: {
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldIsInHouseDelivery: false,
                    fldIsInHouseProduction: false,
                    fldItemsTotalValue: 0,
                    fldGrandGrossValue: 0,
                    fldOtherPlusValue: 0,
                    fldOtherMinusValue: 0,
                    fldRoundoff: 0
                },
                detailsId: ''
            };
        case COMPACTING_DC_DIA_SUCCESS:
            return {
                ...state,
                loading: false,
                diaListStyleCompacting: updatePayload
            }
        case DELETE_COMPACTING_DIV_SUCCESS_CALL_OFF:
            return {
                ...state,
                loading: false,
                callOffCheck: updatePayload
            }
        case FETCH_COMPACTING_DIVISION_DYEING_DCNO_ID_SUCCESS:
            return {
                ...state,
                loading: false,
                DyedDCNOId: updatePayload
            }
        case FETCH_COMPACTING_DC_FAILURE:
        case FETCH_COMPACTING_DC_STYLE_FAILURE:
        case FETCH_SINGLE_COMPACTING_DC_FAILURE:
        case CREATE_COMPACTING_DC_FAILURE:
        case UPDATE_COMPACTING_DC_FAILURE:
        case DELETE_COMPACTING_DC_FAILURE:
        case FETCH_COMPACTING_DC_INVOICE_FAILURE:
        case FETCH_COMPACTING_DC_DETAILS_RATE_FROM_STYLE_FAILURE:
        case COMPACTING_DC_DIA_FALIURE:
        case DELETE_COMPACTING_DIV_FAILURE_CALL_OFF:
        case FETCH_COMPACTING_DIVISION_DYEING_DCNO_ID_FAILURE:
            return {
                ...state,
                loading: false,
                callOffCheck: updatePayload
            }
            return {
                ...state,
                loading: false,
                errorMessage: updatePayload
            };
        case CREATE_USER_FORM_COMPACTING_DC:
            return {
                ...state,
                loading: false,
                userform: {
                    ...state.userform,
                    [payload.key]: payload.value
                }
            };
        case COMPACTING_DC_USERFORM_RESET:
            return {
                ...state,
                userform: {
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldIsInHouseDelivery: false,
                    fldIsInHouseProduction: false,
                    fldItemsTotalValue: 0,
                    fldGrandGrossValue: 0,
                    fldOtherPlusValue: 0,
                    fldOtherMinusValue: 0,
                    fldRoundoff: 0,
                    fldFKUnitId: '',
                    fldFKProgram: '',
                    fldGRNNo: '',
                    fldLotNo: '',
                    fldSupplierDCNo: '',
                    fldSupplierDCDate: '',
                    fldSupplierDCValue: '',
                    startDate: state.userform.startDate,
                    endDate: state.userform.endDate,
                    unitId: state.userform.unitId
                },
                detailsId: '',
                activeKey: 1
            };
        case NAVIGATE_COMPACTING_DC_DETAILS:
            return {
                ...state,
                isCompactingDC: true,
                compactingDCSelectedValue: updatePayload?.compactingDCSelectedValue
            };
        case NAVIGATE_COMPACTING_DC:
            return {
                ...state,
                isCompactingDC: false
            };
        case RESET_COMPACTING_DC_INVOICE_V2:
            return {
                ...state,
                compactingDCInvoiceV2: []
            };
        case COMPACTING_DC_USERFORM_NAVIGATE_TO_DETAIL_TAB:
            return {
                ...state,
                userform: {
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldIsInHouseDelivery: false,
                    fldIsInHouseProduction: false,
                    fldItemsTotalValue: 0,
                    fldGrandGrossValue: 0,
                    fldOtherPlusValue: 0,
                    fldOtherMinusValue: 0,
                    fldRoundoff: 0,
                    startDate: state.userform.startDate,
                    endDate: state.userform.endDate,
                    unitId: state.userform.unitId
                },
                activeKey: 2
            };
        case COMPACTING_DC_USERFORM_NAVIGATE_TO_DETAIL_REVERSE:
            return {
                ...state,
                userform: {
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldIsInHouseDelivery: false,
                    fldIsInHouseProduction: false,
                    fldItemsTotalValue: 0,
                    fldGrandGrossValue: 0,
                    fldOtherPlusValue: 0,
                    fldOtherMinusValue: 0,
                    fldRoundoff: 0,
                    startDate: state.userform.startDate,
                    endDate: state.userform.endDate,
                    unitId: state.userform.unitId
                },
                activeKey: 1
            };
        default:
            return state;
    }
};
